
export default function HeroSection() {
  const handleRegister = () => {
    window.open('https://buy.stripe.com/00w7sEaoVdgx2UlapSgIo01', '_blank');
  };

  return (
    <section className="bg-gradient-to-br from-teal-500 to-emerald-600 py-16 px-4 relative overflow-hidden">
      <div className="absolute inset-0 bg-black/10" />
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-20"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Professional%20business%20meeting%20with%20executives%20silhouettes%20against%20modern%20city%20skyline%2C%20Tokyo%20tower%20visible%2C%20corporate%20atmosphere%2C%20elegant%20office%20setting%2C%20warm%20lighting%2C%20professional%20photography%20style%2C%20business%20success%20concept&width=1200&height=800&seq=hero-bg&orientation=landscape')`
        }}
      />
      
      <div className="max-w-6xl mx-auto relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="text-white text-center lg:text-left">
            <div className="mb-8 flex justify-center lg:justify-start">
              <img 
                src="https://static.readdy.ai/image/33e4d9a6aa73ec1d4a454a3f4917fe46/fab3f1d05ed2f8bcebcebeebc3a84df1.png"
                alt="BIZCHAIN"
                className="h-12 w-auto"
              />
            </div>
            <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold mb-6 text-white">
              BIZCHAIN800
            </h1>
            <p className="text-lg sm:text-xl md:text-2xl mb-8 text-white/90">
              経営者のつながりを<br className="sm:hidden" />もっと深く、もっと豊かに。
            </p>
            <div className="flex justify-center lg:justify-start">
              <button 
                onClick={handleRegister}
                className="bg-white text-teal-600 hover:bg-teal-50 font-semibold px-6 sm:px-8 py-3 sm:py-4 text-base sm:text-lg rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                クレジットカードで登録する
              </button>
            </div>
          </div>
          
          <div className="relative lg:block hidden">
            <img 
              src="https://readdy.ai/api/search-image?query=Three%20business%20executives%20in%20suits%20looking%20out%20large%20office%20window%20at%20Tokyo%20cityscape%20with%20Tokyo%20Tower%2C%20professional%20corporate%20setting%2C%20modern%20office%20interior%2C%20city%20view%2C%20business%20success%2C%20professional%20photography%20style&width=600&height=400&seq=hero-img&orientation=landscape"
              alt="ビジネスマンと東京の景色"
              className="w-full h-auto rounded-lg shadow-2xl object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
